export default __webpack_public_path__ + "c9506d7f103dd4418d3d2b455d31c0f5.svg";